import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LibPageHeaderComponent, LibTermsAndConditionComponent } from '@web-nx-ng-tsc/web-promo-shared-ui';
import { IPageHeaderEntity } from '@web-nx-ng-tsc/web-shared-data-access';
import { IMeta, MetaService } from '@web-nx-ng-tsc/util-meta';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [LibPageHeaderComponent, LibTermsAndConditionComponent],
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.scss',
})
export class PrivacyPolicyComponent {
  // Inject
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly metaService = inject(MetaService);

  pageHeaderObj = signal<IPageHeaderEntity>({
    pageTitle: 'นโยบายความเป็นส่วนตัว',
    pageSubTitle: '(Privacy Policy)',
    subTitles: [
      {
        title: 'หน้าแรก',
        partName: '/',
      },
      {
        title: 'นโยบายความเป็นส่วนตัว (Privacy Policy)',
        partName: '/privacy-policy',
      },
    ],
  });

  privacyPolicyObj = [
    {
      title: 'ขอบเขตการใช้งานเว็บไซต์',
      subtitle: [
        {
          headers:
            'เว็บไซต์นี้จัดทำโดย บริษัท ต.สยามคอมเมอร์เชียล จำกัด("บริษัท") เพื่อให้ข้อมูลเกี่ยวกับผลิตภัณฑ์, ข่าวสาร, และบริการของเรา',
        },
        {
          headers:
            'การใช้เว็บไซต์นี้ถือว่าคุณยอมรับข้อกำหนดและเงื่อนไขที่ระบุไว้ หากคุณไม่ยอมรับ โปรดหยุดการใช้งานเว็บไซต์ทันที',
        },
      ],
    },
    {
      title: 'ลิขสิทธิ์และทรัพย์สินทางปัญญา',
      subtitle: [
        {
          headers:
            'เนื้อหา ข้อความ รูปภาพ วิดีโอ และองค์ประกอบอื่นๆ บนเว็บไซต์นี้เป็นทรัพย์สินของบริษัท ห้ามทำซ้ำ ดัดแปลง หรือแจกจ่ายโดยไม่ได้รับอนุญาตเป็นลายลักษณ์อักษรจากบริษัท',
        },
        {
          headers:
            'เครื่องหมายการค้า ชื่อแบรนด์ และโลโก้ต่างๆ ที่ปรากฏบนเว็บไซต์เป็นกรรมสิทธิ์ของบริษัทหรือผู้อนุญาตให้ใช้สิทธิ ห้ามนำไปใช้โดยไม่ได้รับอนุญาต',
        },
      ],
    },
    {
      title: 'การใช้งานเว็บไซต์อย่างเหมาะสม',
      subtitle: [
        {
          headers: 'ห้ามใช้เว็บไซต์นี้ในลักษณะที่ก่อให้เกิดความเสียหาย, การรบกวน, หรือการกระทำใดๆ ที่ผิดกฎหมาย',
        },
        {
          headers: 'ห้ามทำการอัปโหลดหรือส่งข้อมูลที่เป็นอันตราย เช่น ไวรัส มัลแวร์ หรือสแปม',
        },
        {
          headers: 'ผู้ใช้งานต้องรับผิดชอบต่อข้อมูลหรือการกระทำที่เกิดขึ้นจากบัญชีของตน',
        },
      ],
    },
    {
      title: 'ข้อจำกัดความรับผิดชอบ',
      subtitle: [
        {
          headers: 'บริษัทไม่รับประกันว่าเว็บไซต์จะไม่มีข้อผิดพลาด หรือไม่มีการหยุดชะงัก',
        },
        {
          headers:
            'บริษัทจะไม่รับผิดชอบต่อความเสียหายหรือความสูญเสียใดๆ ที่เกิดขึ้นจากการใช้งานเว็บไซต์ รวมถึงความสูญเสียทางการเงินหรือข้อมูลส่วนบุคคล',
        },
      ],
    },
    {
      title: 'การเปลี่ยนแปลงข้อกำหนด',
      subtitle: [
        {
          headers: 'บริษัทขอสงวนสิทธิ์ในการปรับเปลี่ยนข้อกำหนดและเงื่อนไขได้ตลอดเวลา โดยไม่ต้องแจ้งให้ทราบล่วงหน้า',
        },
        {
          headers: 'การเปลี่ยนแปลงจะมีผลทันทีเมื่อประกาศบนเว็บไซต์',
        },
      ],
    },
    {
      title: 'การเชื่อมโยงไปยังเว็บไซต์บุคคลที่สาม',
      subtitle: [
        {
          headers:
            'เว็บไซต์อาจมีลิงก์ไปยังเว็บไซต์บุคคลที่สามเพื่อความสะดวก แต่บริษัทไม่รับผิดชอบต่อเนื้อหาหรือการใช้งานเว็บไซต์ดังกล่าว',
        },
      ],
    },
  ];

  constructor() {
    this.metaService.updateMeta(this.route.snapshot.data as IMeta);
    this.onSetOpenGraphTags();
  }

  redirectTo(url: string) {
    this.router.navigate([`${url}`]);
  }

  onSetOpenGraphTags() {
    this.metaService.updateOpenGraph({
      title: 'นโยบายความเป็นส่วนตัว | NANKANG Tire Thailand',
      description:
        'อธิบายการเก็บ ใช้ เปิดเผย และคุ้มครองข้อมูลส่วนบุคคลตามกฎหมายที่เกี่ยวข้อง ระบุสิทธิของเจ้าของข้อมูล ช่องทางติดต่อ และมาตรการรักษาความปลอดภัย ให้คุณใช้งานเว็บไซต์และบริการของ NANKANG ได้อย่างมั่นใจ โปร่งใส และสอดคล้องข้อกำหนดเสมอ | NANKANG Tire Thailand',
      image: 'https://tsc-pub-blob.s3.ap-southeast-7.amazonaws.com/2025-08/logo-nankang_result-20250819114138.webp',
    });
  }
}
